import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CodeConfirmationService, CodeConfirmationConfig } from '../../../services/code-confirmation.service';
import { CodeConfirmationDialogComponent } from '../code-confirmation-dialog/code-confirmation-dialog.component';

/**
 * Host global para diálogos de confirmación con código
 * Se incluye en app.component para estar disponible en toda la aplicación
 */
@Component({
  selector: 'app-code-confirmation-host',
  standalone: true,
  imports: [
    CommonModule,
    CodeConfirmationDialogComponent
  ],
  template: `
    <app-code-confirmation-dialog
      [visible]="isVisible"
      [config]="currentConfig"
      [loading]="isLoading"
      (confirmed)="onConfirmed($event)"
      (CANCELED)="onCANCELED()"
      (visibleChange)="onVisibilityChange($event)">
    </app-code-confirmation-dialog>
  `
})
export class CodeConfirmationHostComponent implements OnInit, OnDestroy {
  private codeService = inject(CodeConfirmationService);
  private destroy$ = new Subject<void>();

  isVisible = false;
  isLoading = false;
  currentConfig: CodeConfirmationConfig = {
    title: '',
    message: '',
    expectedCode: ''
  };

  ngOnInit(): void {
    // Suscribirse a los cambios de visibilidad
    this.codeService.visible$
      .pipe(takeUntil(this.destroy$))
      .subscribe(visible => {
        this.isVisible = visible;
      });

    // Suscribirse a los cambios de configuración
    this.codeService.config$
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        if (config) {
          this.currentConfig = config;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onConfirmed(result: any): void {
    this.isLoading = true;
    this.codeService.handleConfirmation(result);
    this.isLoading = false;
  }

  onCANCELED(): void {
    this.codeService.handleCancellation();
  }

  onVisibilityChange(visible: boolean): void {
    if (!visible) {
      this.codeService.hide();
    }
  }
}
